<template>
    <b-modal id="modifyBTableHeader"
             :title="$t('ModifyTableHeader')"
             :ok-title="$t('Confirm')"
             :cancel-title="$t('Dismiss')"
             cancel-variant="outline-secondary"
             ok-variant="success"
             @ok="updateConfiguration"
             effect="fade/zoom">

        <b-form-group>
            <b-table
                hover
                responsive
                :fields="fields"
                :items="editableFields">
                <template v-slot:head()="value">
                    <div class="text-nowrap">{{ value.label }}</div>
                </template>
                <template v-slot:cell(column)="{item}">
                    <span>{{ item.label }}</span>
                </template>
                <template v-slot:cell(show)="{item}">
                    <b-form-checkbox
                        :key="item.key"
                        v-model="item.visible"
                        switch />
                </template>
            </b-table>
        </b-form-group>

    </b-modal>
</template>
<script>

export default {
    name: "BTableHeaderConfiguration",
    data() {
        return {
            dbDefinition: [],
            fields: [
                {
                    key: 'column',
                    label: this.$t('Column'),
                }, {
                    key: 'show',
                    label: this.$t('Show'),
                    class: ['d-flex', 'justify-content-end']
                },
            ],
        }
    },
    props: {
        fieldsSettings: {
            type: Array,
            required: true
        },
        preferenceType: {
            type: String,
            required: true
        },
    },
    mounted() {
        this.getStoredConfiguration();
    },
    computed: {
        editableFields: function () {
            return this.fieldsSettings.filter(function (field) {
                field.visible= field.visible === undefined ? true : field.visible;
                return field.editable === true;
            });
        },
        returnFields: function () {
            return this.fieldsSettings.filter(function (field) {
                return field.visible === undefined || field.visible === true;
            });
        },
        fieldsToBeSaved: function () {
            return this.editableFields.map(function (field) {
                return {key: field.key, visible: field.visible};
            })
        }
    },
    methods: {
        getStoredConfiguration() {
            let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/ui-preference/show`;
            let payload = {type: this.preferenceType};
            return axios.get(url, {params: payload, errorHandle: false} )
                .then((response) => {
                    if(response.status === 200) {
                        if(response.data.definition){
                          let storedConfiguration= response.data.definition;
                            storedConfiguration.forEach((item) => {
                                let obj = this.fieldsSettings.find(entry => entry.key === item.key)
                                if(obj){
                                    obj.visible= item.visible;
                                }
                            })
                        }
                    }
                })
                .catch((error) => {
                    //404
                })
                .finally(() => {
                    this.$emit('changed', this.returnFields);
                });
        },
        updateConfiguration() {
            let url = `${this.$store.getters.getAppUrl}/dealer/api/v2/ui-preference/update`;
            let payload = {
                type: this.preferenceType,
                definition: this.fieldsToBeSaved
            };
            axios.patch(url, payload)
                .then(function (response) {
                    console.log(response.status);
                });
            this.$emit('changed', this.returnFields);
        },
    },
}
</script>
